import { useContext } from 'react';
import { ThemeContext, ThemeSkinContext } from '../../Context';
import { ThemeOptions, ThemeSkin } from '../../publicSession/types';
export function useAvatarSrc(user) {
    var theme = useContext(ThemeContext);
    var themeSkin = useContext(ThemeSkinContext);
    var _a = user || {}, type = _a.type, usericon = _a.usericon, usericonDefault = _a.usericonDefault;
    var isGroup = user && type && type.includes('group');
    var showDefaultUserAvatar = !user || (!isGroup && (usericonDefault || !usericon));
    if (showDefaultUserAvatar) {
        return theme === ThemeOptions.LIGHT
            ? themeSkin === ThemeSkin.GREEN
                ? 'https://st.deviantart.net/eclipse/icons/p07-green.svg?1'
                : 'https://st.deviantart.net/eclipse/icons/p07-light.svg?1'
            : 'https://st.deviantart.net/eclipse/icons/p07-dark.svg?1';
    }
    return usericon;
}
//# sourceMappingURL=useAvatarSrc.js.map